// No need to return anything becuase a HiddenBox is never rendered.
// Always excluded by HideField function in DynamicFormProvider
export default () => null;
